import { Component, OnInit,ViewChild, Input, Type, TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {SubmitdataService} from "src/app/services/submitdata/submitdata.service";
import { TableConstantsModule } from 'src/app/common/constants/tableconstants.module';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { element } from 'protractor';
import { ActivatedRoute } from '@angular/router';
import {NgbModal, NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {UtilsModule} from 'src/app/common/utils/utils.module';
import { DatePipe } from '@angular/common';
import { type } from 'os';
import { isNullOrUndefined } from 'util';

import { TranslateService } from '@ngx-translate/core';
// import { RejectwindowPopupComponent } from '../rejectwindow-popup/rejectwindow-popup.component';
import { of } from 'rxjs';
import { viewDef } from '@angular/core/src/view';
import { timeStamp } from 'console';


@Component({
  selector: 'app-datasubmitapprovals',
  templateUrl: './datasubmitapprovals.component.html',
  styleUrls: ['./datasubmitapprovals.component.css']
})
export class DatasubmitapprovalsComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport, {})
  @ViewChild('testModal',{}) testModal;
  @ViewChild('confirmModal',{})confirmModal;
  @ViewChild('submitModal',{})submitModal;
  @ViewChild('deleteModal',{})deleteModal;
  @ViewChild('alertModal',{})alertModal;
  @Input() distname;
  @Input() labeldata
  @Input() subtimeperiod;

  // @Input() usertab : String;
  usertab;
  showdistcolumn : boolean
  distuuid = "null";
  datasubmit = 'statewise';
  datasubmitstate = 'districtwise';
  selectedistrict:any;
  showdistdropdown : boolean;
  districtflag : boolean;
  checkall = false;
  DistrictList = []
  state_nodal_officer : String;
  dist_nodal_officer :string;
  public viewPort: CdkVirtualScrollViewport;
  tableData  = [];
  sortedTableData = [];
  stateDropDownList = [];
  stateuuid = "null";
  reportsdata;
  historydata;
  urlparams;
  activeSpinner : boolean;
  hierarchydata;
  userdetails = {};
  userlocationtype = null;
  yearDropDownList;
  assessmentYear;
  activesidetab;
  TableHeader : any;
  activespineer : Boolean;
  windowdata : any;
  disableedit : boolean = false;
  datasubmissndistlevel : boolean = false;
  datasubmitlevel :boolean = false;
  validation: boolean[] = new Array(1).fill(true);
  districtdropdownlist: any;
  selectedstate : any;
  dateofMeetingPresent:boolean=false;
  monthList:any = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
  ];
  yeardisbaled: boolean;
  validation_officer: string;
  subindicators: any=[];
  dataSubmitFilter : object = {'montharray':'','ay':''};
  subindicatorsValues: any = [];
  subindicatorValue: any= [];
  selectedMonth: any;
  monthsList: any;
  dynamicTableData: any= [];
  dynamicindicators: any;
  nallatable: boolean;
  springTableData: any = [];
  wetlandTableData: any = [];
  availabilityTableData: any = [];
  rivertabledata : any =[];
  industrytabledata : any = [];
  noncomplainData: any = [];
  nallatabledata : any= [];
  percentagetabledata: any = [];
  stpyestabledata:any = [];
  stpnotabledata:any=[];
  reusagetabledata: any = [];
  subindicatorUUID: any = [];
  childList: any[];
  dynamicdata: any[];
  stateindValue: any;
  historytableobj: any[];
  historylabel: any = [];
  historydatavalue: any =[];
  nallalabel: any;
  stateArrayList: any[];
  districtarrayList: any[];
  showdistrictdrop: any;
  filterdistrict: any;
  selectedId: any;
  fileid: any[];
  modalRef: any;
  selectedAction: any;
  showTable: boolean = true;
  rejectWindowObj: any[];
  modalReference: any;
  themearrayObject: any[];
  descriptedData: any[];
  meetingData: any;
  downloadData: any;
  monthsmap: any;
  filedata: any;
  showDoc1: boolean;
  filedataObj: any;
  showDoc2: boolean;
  showImage2: boolean;
  showImage1: boolean;
  subfileobj: any;
  subimgobj: any;
  hideRow: boolean ;
  selectedVariable: any;
  history3_1_d: boolean = false;
  stpnotabledata2: any;
  constructor(private submitdataservice : SubmitdataService,
    private modalService : NgbModal,
    public tableconstants : TableConstantsModule,
    private constants : ConstantsModule,
    private logsrv : AuthloginService,
    private toastr : ToastrService,
    private route: ActivatedRoute,
    public utils : UtilsModule,
    private translate: TranslateService,
    private datepipe : DatePipe
    ) { 
      translate.setDefaultLang('en');
    }

  ngOnInit() {
    this.submitdataservice.getStatusOfToken();
    this.fetchAssesmentYear();
    this.userdetails = this.logsrv.checkloginstatus();
    // console.log(this.userdetails)
    this.navtabclick('approval');
    this.getstatesdata();
    // this.labeldata.forEach(element => {
    //   if(this.subtimeperiod == element['key']){
    //     this.monthsmap = element['value']
    //   }
    // });
  } 
  initonstateload(){
    this.urlparams = this.submitdataservice.getWritableObject(this.route.snapshot.params)
    this.usertab = this.urlparams['component'];
    this.userdetails = this.logsrv.checkloginstatus();
    // console.log(this.userdetails)
    this.userlocationtype = this.userdetails['loggedUserData']['userProfile']['locationType']
    // this.getLocationList();
    // this.yeardisabling();
    this.state_nodal_officer = this.constants.USER_TYPES["STATE_NODAL_OFFICER"];
    this.dist_nodal_officer  = this.constants.USER_TYPES['DISTRICT_NODAL_OFFICER'];
    this.validation_officer = this.constants.USER_TYPES['VALIDATION_AGENCY'];
    this.monthsList = this.monthList;
    // this.yearDropDownList = this.submitdataservice.getassesmentYear();
    // this.districtdropdownlist = this.submitdataservice.getAssesmentYearDistrict();
    // this.dataSubmitFilter['ay'] = this.yearDropDownList[this.yearDropDownList.length-1];
    this.setCurrentMonthDefault();
    this.getTabledata();
    // if(this.urlparams['component'] != 'approvals'){
    //   this.getassesmentunit();
    // }
    this.getReports();
  }
  async getWindowStatus(uuidlist){
    let options = {};
    options["childlist"] = (this.state_nodal_officer == this.userdetails['roles'][0] || this.dist_nodal_officer == this.userdetails['roles'][0])? [this.getbasicparams()['lu']] : uuidlist,
    options["yearlist"] = this.submitdataservice.getassesmentYear(),
    options["view"]  = this.constants.VIEWS['admin'];
    options["cType"] = this.state_nodal_officer == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['STATE'] : this.constants.LOCATION_CONSTANT['DISTRICT']
    this.windowdata = await this.submitdataservice.getWindowStatus(options);
    if(this.state_nodal_officer == this.userdetails['roles'][0])
     this.disableedit = this.submitdataservice.checkwindow(this.windowdata,this.dataSubmitFilter['ay'],this.getbasicparams()['lu']);
  }
  fetchAssesmentYear(){
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }
    this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    })
    this.dataSubmitFilter['ay'] = dropDownYear;
  }
  // yearchanged(fieldvalue){
  //   if(fieldvalue){
  //     this.callfn();
  //   }
  //     // this.disableedit = this.submitdataservice.checkwindow(this.windowdata,fieldvalue,this.getbasicparams()['lu']);
  // }
  selectOption(month){
    this.dataSubmitFilter['montharray'] = month
  }
  dataSubmissionChange(){

  }
  setCurrentMonthDefault(){
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj =>{
      if(parseInt(monthObj['key'])  == currentmonth + 1){
        currentmonthObj = monthObj;
      }
    });
    this.dataSubmitFilter['montharray'] = currentmonthObj['key'];
  }
  // yeardisabling(){
  //   if(this.userdetails && this.userdetails['roles'][0] == 'VALIDATION_AGENCY' || this.userdetails && this.userdetails['roles'][0] == 'ADMIN' || this.userdetails && this.userdetails['roles'][0] == 'STATE_NODAL_OFFICER'){
  //     if(this.dataSubmitFilter['ay'] == '2019-2020'){
  //       this.yeardisbaled = true;
  //     } else{
  //       this.yeardisbaled = false;
  //     }
  //   }
  // }
  getTabledata(){
    // console.log(this.dataSubmitFilter['montharray']);
    this.descriptedData =[];
    let reportdata = {
      "ay" : this.dataSubmitFilter['ay'],
      "view" : this.constants.VIEWS['admin'],
      "cType" : this.constants.LOCATION_CONSTANT['DISTRICT'],
      "userType":this.userdetails['roles'][0],
      "lu" : this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'],
      "subTp" : this.dataSubmitFilter['montharray'],
    }
    this.activeSpinner = true;
    this.submitdataservice.getfetchmeetingDetails(reportdata).subscribe(rawdata =>{
      this.activeSpinner = false;
      this.meetingData = rawdata;
      let item = rawdata['meetings'];
      Object.keys(item).forEach(tp =>{
        let data ={};
        if(item[tp]['description'] != "[]"){
          let array : any = item[tp]['description'];
          let arraySplit = array.split("[");
          let labels = arraySplit[1].split("]");
          let finalLabel = labels[0].split(",").join(", ");       
          data['desc'] = finalLabel;          
        } else {
          data['desc'] = ""
        }
        if(item[tp]['date'] != null){
          data['date'] = item[tp]['date'];
        } else {
          data['date'] = ""
        }
        this.descriptedData.push(data);
      })
      this.formatMeetingTableData(rawdata);
    });
  }
  formatdate(date){
    if (date.length>0){
      this.dateofMeetingPresent=true;
    }
    return this.utils.getDateInFormatFromModelDate(date.toString(),"dd-MM-yyyy")   
  }
  formatMeetingTableData(rawdata: any) {
    let attendanceMeetings = {};
    attendanceMeetings = rawdata['meetings'];
    if(Object.keys(attendanceMeetings).length > 0){
     Object.keys(attendanceMeetings).forEach(date =>{
       let attdata = JSON.parse(attendanceMeetings[date]['attendance']);
        this.hidefileOBj(attdata);
        this.hideimgObj(attdata);
        this.hidesubFile(attdata);
        this.hidesubImage(attdata)  
     })
    }
     
  }
  hidefileOBj(data){
    this.filedata = data['document'];
    if(this.filedata){
     this.showDoc1 = true;
    } else{
      this.showDoc1 = false;
    }
   }
   hideimgObj(data){
    this.filedataObj = data['image'];
    if(this.filedataObj){
      this.showImage1 = true;
    } else{
      this.showImage1 = false;
    }
  }
  hidesubFile(attdata: any) {
    this.subfileobj = attdata['document_a'];
    if(this.subfileobj){
      this.showDoc2 = true;
    } else{
      this.showDoc2 = false;
    }
   }
   hidesubImage(attdata: any) {
    this.subimgobj = attdata['image_a'];
    if(this.subimgobj){
      this.showImage2 = true;
    } else{
      this.showImage2 =false;
    }
   } 
  downloadFile1(){
    this.monthsList.forEach(element => {
      if(this.dataSubmitFilter['montharray'] == element['key']){
        this.selectedVariable = element['value']
      }
    });
    let docmnt;
    let downldObj = {};
    let obj = {};
    obj = this.meetingData['meetings'];
    Object.keys(obj).forEach(key =>{
      docmnt = JSON.parse(obj[key]['attendance'])
    });
     downldObj['fileUUID'] = docmnt['document'];
     this.submitdataservice.downloadExcelDatas(downldObj).subscribe(data=>{
      if(!Array.isArray(data)){
        let fname= this.userdetails['loggedUserData']['userProfile']['locationName']+"district Meeting Report"+"_"+this.dataSubmitFilter['ay'] + this.selectedVariable

        if(data.type != "application/json"){
          switch(data.type){
            case 'image/png':{
              fname+='.png'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':{
              fname+='.docx'
              break;
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
              fname+='.pptx'
              break
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
              fname+='.ppt'
              break
            }
            case 'application/octet-stream':{
              // fname+='.jpg'
              fname+='.pdf'
              break;
            }
            case 'application/excel':{
              fname+='.xlsx'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':{
              fname+='.xls'
              break;
            }
            case 'image/jpeg':{
              fname+='.jpeg'
              break;
            }
            case 'text/plain':{
              fname+='.txt'
              break;
            }
            case 'application/pdf':{
              fname+='.pdf'
              break;
            }
            case 'image/jpg':{
              fname+='.jpg'
              break;
            }
            default:{
              break;
            }
          }
          
          this.utils.downloadFile(data,fname);

        } else {
          this.toastr.error("some exception occured")
        }

      }
     })
  }
  downloadFile2(){
    this.monthsList.forEach(element => {
      if(this.dataSubmitFilter['montharray'] == element['key']){
        this.selectedVariable = element['value']
      }
    });
    let docmnt;
    let downldObj = {};
    let obj = {};
    obj = this.meetingData['meetings'];
    Object.keys(obj).forEach(key =>{
      docmnt = JSON.parse(obj[key]['attendance'])
    });
    downldObj['fileUUID'] = docmnt ? docmnt['document_a'] : null
     this.submitdataservice.downloadExcelDatas(downldObj).subscribe(data=>{
      if(!Array.isArray(data)){
        let fname= this.userdetails['loggedUserData']['userProfile']['locationName']+"district Meeting Report"+"_"+this.dataSubmitFilter['ay'] + this.selectedVariable
        
        if(data.type != "application/json"){
          switch(data.type){
            case 'image/png':{
              fname+='.png'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':{
              fname+='.docx'
              break;
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
              fname+='.pptx'
              break
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
              fname+='.ppt'
              break
            }
            case 'application/octet-stream':{
              // fname+='.jpg'
              fname+='.pdf'
              break;
            }
            case 'application/excel':{
              fname+='.xlsx'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':{
              fname+='.xls'
              break;
            }
            case 'image/jpeg':{
              fname+='.jpeg'
              break;
            }
            case 'text/plain':{
              fname+='.txt'
              break;
            }
            case 'application/pdf':{
              fname+='.pdf'
              break;
            }
            case 'image/jpg':{
              fname+='.jpg'
              break;
            }
            default:{
              break;
            }
          }
          
          this.utils.downloadFile(data,fname);

        } else {
          this.toastr.error("some exception occured")
        }

      }
     })
  }
  downloadImage1(){
    let attdata : any;
    let filesObj = {};
    let obj = {};
    obj = this.meetingData['meetings'];
    Object.keys(obj).forEach(key =>{
      attdata = JSON.parse(obj[key]['attendance']);
    });
    filesObj['fileUUID'] = attdata['image'];
    this.submitdataservice.downloadExcelDatas(filesObj).subscribe(data=>{
      // console.log(data.type)
      if(!Array.isArray(data)){
        let fname= "Image1"
        switch(data.type){
          case 'image/png':{
            fname+='.png'
            break;
          }
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':{
            fname+='.docx'
            break;
          }
          case 'application/excel':{
            fname+='.xlsx'
            break;
          }
          case 'application/octet-stream':{
            fname+='.jpg'
            break;
          }
          case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
            fname+='.pptx'
            break
          }
          case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
            fname+='.ppt'
            break
          }
          case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':{
            fname+='.xls'
            break;
          }
          case 'application/octet-stream':{
            fname+='.jpg'
            break;
          }
          case 'image/jpeg':{
            fname+='.jpeg'
            break;
          }
          case 'text/plain':{
            fname+='.txt'
            break;
          }
          case 'application/pdf':{
            fname+='.pdf'
            break;
          }
          case 'image/jpg':{
            fname+='.jpg'
            break;
          }
          default:{
            break;
          }
        }
    
        this.utils.downloadFile(data,fname);
      }
    })

  }
  downloadImage2(){
    let attdata : any;
    let filesObj = {};
    let obj = {};
    obj = this.meetingData['meetings'];
    Object.keys(obj).forEach(key =>{
      attdata = JSON.parse(obj[key]['attendance']);
    });
    filesObj['fileUUID'] = attdata ? attdata['image_a'] : null
    // if(attdata && attdata['image_a']!="null"){
      this.submitdataservice.downloadExcelDatas(filesObj).subscribe(data=>{
        if(!Array.isArray(data)){
          let fname= "Image2"
          switch(data.type){
            case 'image/png':{
              fname+='.png'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':{
              fname+='.docx'
              break;
            }
            case 'application/excel':{
              fname+='.xlsx'
              break;
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
              fname+='.pptx'
              break
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
              fname+='.ppt'
              break
            }
            case 'application/octet-stream':{
              fname+='.jpg'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':{
              fname+='.xls'
              break;
            }
            case 'image/jpeg':{
              fname+='.jpeg'
              break;
            }
            case 'text/plain':{
              fname+='.txt'
              break;
            }
            case 'application/pdf':{
              fname+='.pdf'
              break;
            }
            case 'image/jpg':{
              fname+='.jpg'
              break;
            }
            default:{
              break;
            }
          }
      
          this.utils.downloadFile(data,fname);
  
        }
  
      })
    
  }
  getHistoryData(){
    // this.showdistcolumn = this.districtflag ? true : false
    let historydata = {};
     historydata = this.historyparams();
    if(this.userdetails['isReadOnly']){
      historydata['isReadOnly'] = this.userdetails['isReadOnly']
    }
    this.historytableobj = [];
    this.submitdataservice.gethistorydata(historydata).subscribe(data =>{
      if(!isNullOrUndefined(data)){
      this.historydata = data['data'];
      if(Object.keys(this.historydata).length > 0){
          this.getIndicatorsHeirarchy('history');
        // }
      } else {
        this.historytableobj = [];
      }
    }
    });
  }
  getalldistuuids(){
    let array = [];
    this.DistrictList.forEach(element => {
      array.push(element['uuid'])
    });
    return array;
  }
  callfn(){
    this.showDoc1 = false;
    this.showDoc2 = false;
    this.showImage1 = false;
    this.showImage2 = false;
    this.dateofMeetingPresent = false;
    this.datasubmitlevel = this.datasubmit == 'districtwise' ? true : false;
    let flag = false;
    if(this.urlparams['component'] == 'approvals' || this.urlparams['component'] == 'datasubmitapprovals' ){
      flag = true
    }
    if(flag){
      if(this.activesidetab == "history"){
        this.getHistoryData();
        this.getTabledata();
      } else {
        this.getTabledata();
        this.getReports();
      }
    }
  }
  public navtabclick(type){
    if(type == this.activesidetab)
     return

    this.activesidetab = type;
    this.TableHeader = this.tableconstants['APPROVAL_TABLE_HEADERS']['GEC_CENTRAL_ADMIN'][type];
    if(type == "history"){
      this.getHistoryData();
    } else {
      this.initonstateload();
    }
  }
  downloadFilesfordata(subuuid){
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    this.submitdataservice.getValidateReports(optionaldata).subscribe(data =>{
      Object.keys(data).forEach(key =>{
        Object.keys(data[key]).forEach(ind =>{
          Object.keys(data[key][ind]).forEach(childdata =>{
            let statehierachydata = {};
            statehierachydata = data[key][ind][childdata];
            if(Object.keys(statehierachydata).length > 0){
              statehierachydata['childData'].forEach(list => {
                if(subuuid == list['id']){
                  let dowloadingdata = {
                    "fileUUID":list['fileUUID'],
                    "id" :subuuid
                  }
                  this.activeSpinner =true;
                  this.submitdataservice.downloadExcel(dowloadingdata).subscribe(result =>{
                    this.activeSpinner = false;
                   if(!Array.isArray(result)){
                     let fname='report'
                     if(result.type != "application/json"){

                     switch(result.type){
                       case 'image/png':{
                         fname+='.png'
                         break;
                       }
                       case 'application/excel':{
                         fname+='.xlsx'
                         break;
                       }
                       case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':{
                         fname+='.xls'
                         break;
                       }
                       case 'image/jpeg':{
                         fname+='.jpeg'
                         break;
                       }
                       case 'text/plain':{
                         fname+='.txt'
                         break;
                       }
                       case 'application/pdf':{
                         fname+='.pdf'
                         break;
                       }
                       case 'image/jpg':{
                         fname+='.jpg'
                         break;
                       }
                       default:{
                         break;
                       }
                     }
                 
                     this.utils.downloadFile(result,fname);

                    } else {
                      this.toastr.error("some exception occured")
                    }
                   }
                  })
                }
              });
            }
          })
        })
      })
    })

 }

  async getassesmentunit(){
   let options = {
     "st" : this.urlparams['component'] == 'approvals' ? (this.stateuuid != 'null' ? this.stateuuid : null) : this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'],
     "userId" : this.userdetails['loggedUserData']['userProfile']['userId']
   }
  this.showdistdropdown = await this.submitdataservice.getAssesmentData(options);
  if(this.showdistdropdown == false){
    this.districtflag = false
  }
  this.activeSpinner = false;
  if(this.showdistdropdown && this.urlparams['component'] != 'approvals'){
    this.getLocationForDistrict();
  } else if(this.showdistdropdown && this.stateuuid){
    this.getLocationForDistrict();
  }
}

typechanged(){
  if(this.datasubmit == 'statewise'){
   this.districtflag = false;
  } else  {
    this.districtflag = true;
  }
}
showdistrictdropdown(stateuuid){
  this.filterdistrict = stateuuid;
  if(this.stateuuid){
    this.showdistrictdrop = true;
  } else{
    this.showdistrictdrop = true;
  }
  if(this.showdistrictdrop){
    this.getdistrictList();
  }
}
getdistrictList(){
  this.districtarrayList = [];
  let postdata = {
    'pType':this.constants.LOCATION_CONSTANT['STATE'],
    'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
    'puuid': this.filterdistrict
  }
  // this.activeSpinner = true;
  this.submitdataservice.getLocationListforUser(postdata).subscribe(data =>{
    // this.activespineer = false;
    if(Array.isArray(data)){
      this.districtarrayList = data;
      this.districtarrayList.sort((a, b) => (a.name > b.name) ? 1 : -1);
    }
  });
}
getstatesdata(){
  let postdata = {};
  this.stateArrayList = [];
  postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
  postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
  postdata["component"] = "";
  postdata["src"] = "";
  this.submitdataservice.getLocationList(postdata).subscribe(data =>{
    if(data){
      Object.keys(data).forEach(key =>{
        data[key].forEach(statelist => {
          this.stateArrayList.push(statelist);
          this.stateArrayList.sort((a, b) => (a.name > b.name) ? 1 : -1);
        });
      })
    }
  })
}

  getReports(){
    this.showTable = false;
    this.showdistcolumn = this.districtflag ? true : false 
    this.checkall = false;
    let postdata = {};
    postdata = this.getbasicparams();
    this.tableData = [];
    this.submitdataservice.getValidateReports(postdata).subscribe(data =>{
      this.reportsdata = data; 
      //console.log("repoooo",this.reportsdata);

      if(Object.keys(this.reportsdata).length > 0){
          this.getIndicatorsHeirarchy("aproval");
      } else {
        this.tableData = [];
        this.showTable = true;
      }
    });
  }
  getdistuuid(selectedistrict){
    this.selectedId = selectedistrict;
  }
  downloadIndicatorFile(induuid){
    // console.log('induuid for download',induuid);
   let postdata = {};
  postdata = this.getbasicparams();
  this.submitdataservice.getValidateReports(postdata).subscribe(data =>{
    Object.keys(data['pending']).forEach(key =>{
      Object.keys(data['pending'][key]).forEach(idkey =>{
        if(induuid == data['pending'][key][idkey]['id']){
          let downloadfiles = {
            "fileUUID" : data['pending'][key][idkey]['file_uuid'],
            "id": induuid,
          };
          this.submitdataservice.downloadExcelDatas(downloadfiles).subscribe(filedata =>{
            if(!Array.isArray(filedata)){
              let fname='report'
              if(filedata.type != "application/json"){

              switch(filedata.type){
                case 'image/png':{
                  fname+='.png'
                  break;
                }
                case 'application/excel':{
                  fname+='.xlsx'
                  break;
                }
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':{
                  fname+='.xls'
                  break;
                }
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':{
                  fname+='.docx'
                  break;
                }
                case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
                  fname+='.pptx'
                  break
                }
                case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
                  fname+='.ppt'
                  break
                }  
                case 'image/jpeg':{
                  fname+='.jpeg'
                  break;
                }
                case 'text/plain':{
                  fname+='.txt'
                  break;
                }
                case 'application/pdf':{
                  fname+='.pdf'
                  break;
                }
                case 'image/jpg':{
                  fname+='.jpg'
                  break;
                }
                default:{
                  break;
                }
              }
              // console.log(fname)
          
              this.utils.downloadFile(filedata,fname);

            } else {
              this.toastr.error("some exception occured")
            }
            }
          })
        }
      })
    })
  })
  }
  downloadFiles(uuid){
    let postdata = {};
    postdata = this.getbasicparams();
    this.submitdataservice.getValidateReports(postdata,).subscribe(data =>{
      Object.keys(data['pending']).forEach(key=>{
        Object.keys(data['pending'][key]).forEach(idkey=>{
          if(uuid == data['pending'][key][idkey]['id']){
             let downloadpostdata = {
             "fileUUID" : data['pending'][key][idkey]['file_uuid'],
             "id" : uuid,
             };
            this.submitdataservice.downloadExcelDatas(downloadpostdata).subscribe(data =>{
              if(!Array.isArray(data)){
                // let fname = ("DownloadReport") +"_" + (new Date()).getTime() + ".xls" &&("DownloadReport") +"_" + (new Date()).getTime() + ".xsls" && ("DownloadReport") +"_" + (new Date()).getTime() + ".pdf" &&("DownloadReport") +"_" + (new Date()).getTime() + ".jpg"  &&("DownloadReport") +"_" + (new Date()).getTime() + ".jpeg" &&("DownloadReport") +"_" + (new Date()).getTime() + ".png" 
                let fname='report'
                // console.log(data.type)
                switch(data.type){
                  case 'image/png':{
                    fname+='.png'
                    break;
                  }
                  case 'application/excel':{
                    fname+='.xlsx'
                    break;
                  }
                  case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':{
                    fname+='.xls'
                    break;
                  }
                  case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':{
                    fname+='.docx'
                    break;
                  }
                  case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
                    fname+='.pptx'
                    break
                  }
                  case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
                    fname+='.ppt'
                    break
                  }  
                  case 'image/jpeg':{
                    fname+='.jpeg'
                    break;
                  }
                  case 'text/plain':{
                    fname+='.txt'
                    break;
                  }
                  case 'application/pdf':{
                    fname+='.pdf'
                    break;
                  }
                  case 'image/jpg':{
                    fname+='.jpg'
                    break;
                  }
                  default:{
                    break;
                  }
                }
            
                this.utils.downloadFile(data,fname);

              }
          });
        }
      });
      })
    });
  }
  getIndicatorsHeirarchy(type){
      this.activeSpinner = true;
      let postdata = {};
      postdata['ay'] = this.dataSubmitFilter['ay'];
      postdata['type'] = this.userlocationtype
      if(this.userlocationtype == 'country' || this.userlocationtype == 'STATE'){
        postdata['type'] = this.datasubmit == 'districtwise' ? 'DISTRICT' : 'STATE'
      }
      this.submitdataservice.FetchIndicators(postdata).subscribe(data =>{
        if(type != 'history'){
          this.preparedataforApproval(data);
          this.dynamicTableData=[];
          this.springTableData=[];
          this.wetlandTableData=[];
          this.rivertabledata=[];
          this.industrytabledata=[];
          this.noncomplainData=[];
          this.nallatabledata=[];
          this.percentagetabledata=[];
          this.reusagetabledata=[];
          this.availabilityTableData=[];
          this.prepareDataforHardcodedTable(data);
        } else{
          this.prepareHistoryData(data);
          this.preparehardcodedhistoryTables(data);
         }
        this.activeSpinner = false;
      });
  }
  prepareHistoryData(data) {
    data.forEach(theme => {      
      let i = 0;
      theme['childList'].forEach(indlist => {
        if (indlist['year'] == this.dataSubmitFilter['ay']) {
          indlist['ischecked'] = false;
          let historytabledata = [];
          Object.keys(this.historydata).forEach(element => {
            Object.keys(this.historydata[element]).forEach(type => {
              this.historydata[element][type].forEach(history => {
                if (history['indicatorUUID'] == indlist['entityUUID']) {
                  let obj = history;
                  if(indlist['entityUUID'] == "aff6273a-fd36-458a-9b99-5758f5278edd"){
                    obj['sno'] = '2.10';                  
                  } else {
                    obj['sno'] = indlist['sno'];
                  }
                  obj['label'] = indlist['label'];
                  let valueobj = JSON.parse(obj['description']);
                  if(indlist['childList'] && indlist['childList'].length > 0){
                    this.historylabel = [];
                    this.historydatavalue =[];
                    obj['numdenflag'] = true;
                    indlist['childList'].forEach(subind => {
                     
                      this.historylabel.push({label:subind['label']});
                    });
                    let historychilds = JSON.parse(obj['childData']);
                    // if(!isNullOrUndefined(historychilds)){
                    //   historychilds.forEach(childs => {
                    //     this.historydatavalue.push({value:childs['value']})
                    //     });
                    // }
                    if(!isNullOrUndefined(historychilds)){
                      historychilds.forEach(childs => {
                        if(childs['wrg']){
                          this.history3_1_d = true;
                          this.historydatavalue.push({value:childs['value'],wrg:childs['wrg']});
                        } else {
                          this.historydatavalue.push({value:childs['value']});
                        }                        
                        // console.log(this.historydatavalue)
                        });
                    }
                  }
                  obj['labeldata'] = this.historylabel;
                  obj['valuedata'] = this.historydatavalue;
                  obj['distname'] = history['userName']
                  obj['value'] = type == "SUBMIT" ? valueobj['val'] :
                    (type == "MODIFY" ? valueobj['updatedVal'] : ((type == "APPROVE" || type == "REJECT") && valueobj['updatedVal'] ? valueobj['updatedVal'] : valueobj['val']))
                  historytabledata.push(obj);
                }
              })
            });
          });
          if(historytabledata){
            
            historytabledata.forEach(element=>{
              i++;
              if(i == 1){
                this.historytableobj.push(theme);
              }
              this.historytableobj.push(element);
              // console.log(this.historytableobj)
            })
          }
          
        }
      });
    });
    
  }
  preparehardcodedhistoryTables(data){
    data.forEach(theme => {
    theme['childList'].forEach(indlist => {
      if (indlist['year'] == this.dataSubmitFilter['ay']) {
        Object.keys(this.historydata).forEach(element => {
          Object.keys(this.historydata[element]).forEach(type => {
            this.historydata[element][type].forEach(history => {
              if (history['indicatorUUID'] == indlist['entityUUID']){
                let obj = history;
                if(obj['isDynamic'] && indlist['label'] == "Number of Nalla's in the district flowing into tributaries or Ganga directly"){
                  let childdataobj = JSON.parse(obj['childData']);
                  childdataobj.forEach(dynamicind => {
                    this.dynamicTableData.push(dynamicind);
                  });
                } else if(obj['isDynamic'] && indlist['label'] == "Small River rejuvenation"){
                  let childdataobj = JSON.parse(obj['childData']);
                  childdataobj.forEach(dynamicind => {
                    this.rivertabledata.push(dynamicind);
                  });
                } else if(obj['isDynamic'] && indlist['label'] == "Spring Rejuvenation"){
                  let childdataobj = JSON.parse(obj['childData']);
                  childdataobj.forEach(dynamicind => {
                    this.springTableData.push(dynamicind);
                  });
                } else if(obj['isDynamic'] && indlist['label'] == "Wetland conservation"){
                  let childdataobj = JSON.parse(obj['childData']);
                  childdataobj.forEach(dynamicind => {
                    this.wetlandTableData.push(dynamicind);
                  });
                } else if(obj['isDynamic'] && indlist['label'] == "List of Gross Polluting Industries (GPI)") {
                    let childdataobj = JSON.parse(obj['childData']);
                    childdataobj.forEach(dynamicind => {
                      this.industrytabledata.push(dynamicind);
                    });
                } else if(obj['isDynamic'] && indlist['label'] == "Action taken against non-compliant Industries"){
                  let childdataobj = JSON.parse(obj['childData']);
                  childdataobj.forEach(dynamicind => {
                    this.noncomplainData.push(dynamicind);
                  });
                } else if(obj['isDynamic'] && indlist['label'] == "Tapping of Nalla's"){
                  let childdataobj = JSON.parse(obj['childData']);
                  childdataobj.forEach(dynamicind => {
                    this.nallatabledata.push(dynamicind);
                  });
                } else if(obj['isDynamic'] && indlist['label'] == "Percentage of work completed for new STPs under construction"){
                  let childdataobj = JSON.parse(obj['childData']);
                  childdataobj.forEach(dynamicind => {
                    this.percentagetabledata.push(dynamicind);
                  });
                } else if(obj['isDynamic'] && indlist['label'] == "Reuse of treated waste water for different purposes mentioned below"){
                  let childdataobj = JSON.parse(obj['childData']);
                  childdataobj.forEach(dynamicind => {
                    this.reusagetabledata.push(dynamicind);
                  });
                } else if(obj['isDynamic'] && indlist['label'] == "Availability of fecal sludge treatment plants"){
                  let childdataobj = JSON.parse(obj['childData']);
                  childdataobj.forEach(dynamicind => {
                    this.availabilityTableData.push(dynamicind);
                  });
                } else if(obj['isDynamic'] && indlist['label'] == "Are all STPs in the district operational"){
                  //console.log('stypestabledata');
                  let childdataobj = JSON.parse(obj['childData']);
                  childdataobj.forEach(dynamicind => {
                    this.stpyestabledata.push(dynamicind);
                    //console.log('dynamicind',dynamicind);
                  });
                }
              }
            });
          });
        });
      }
    });
    });
  }
  preparedataforhtml(data){
    let index = 0;
    data.forEach(theme => {
      // this.tableData.push(element);
      let i = 0;
      theme['childList'].forEach(list => {
        let frommodified = false;
        if(list['year'] == this.dataSubmitFilter['ay']){
          list['ischecked'] = false;
          let stateindicators = {};
          let indicatorsdata = []
          Object.keys(this.reportsdata).forEach(key=>{
            if(this.userdetails['roles'][0] != this.state_nodal_officer && this.userdetails['roles'][0] != this.dist_nodal_officer){

            Object.keys(this.reportsdata[key]).forEach(element=>{
              Object.keys(this.reportsdata[key][element]).forEach(indid => {
                if(element == list['entityUUID']){
                  this.reportsdata[key][element][indid]['val'] = this.reportsdata[key][element][indid]['updatedVal'] ?   this.reportsdata[key][element][indid]['updatedVal'] : this.reportsdata[key][element][indid]['val']
                  this.reportsdata[key][element][indid]['ip'] = list['ip'];
                  this.reportsdata[key][element][indid]['sno'] = list['sno']
                  if(list['childList'] && list['childList'].length > 0){
                    this.reportsdata[key][element][indid]['numdenflag'] = true;
                  }
                  indicatorsdata.push(this.reportsdata[key][element][indid]);
                }
              });
            });
            } else {
              Object.keys(this.reportsdata[key]).forEach(element=>{
                Object.keys(this.reportsdata[key][element]).forEach(indid => {
                  if(element == list['entityUUID']){
                    stateindicators = this.reportsdata[key][element][indid];
                    if(list['childList'] && list['childList'].length > 0){
                      stateindicators['numdenflag'] = true;
                    }
                    if(key == 'modified'){
                      frommodified = true;
                    }
                  }
                });
              });
            }
          });
          if(Object.keys(stateindicators).length > 0){
            list['par'] = stateindicators['par'];
            list['statename'] = this.getstatename(stateindicators,"par");
            if(this.districtflag){
              list['distname'] = this.getdistname(stateindicators,"par")
            }
            list['value'] = frommodified ? stateindicators['updatedVal'] : stateindicators['val'];
            list['updatedvalue'] = stateindicators['updatedVal'];
            list['status'] = stateindicators['status'] ? stateindicators['status'].toUpperCase() : null;
            list['label'] = stateindicators['name'];
            if(stateindicators['numdenflag']){
              list['numdenflag'] = true;
              list['numerator_value'] = stateindicators['numerator'];
              list['updatednumvalue'] = stateindicators['updatedNumenator'];
              list['denominator_value'] = stateindicators['denominator'];
              list['updateddenovalue'] = stateindicators['updatedDenominator'];
              list['numerator_label'] = stateindicators['numerator_label'];
              list['denominator_label'] = stateindicators['denominator_label'];
            }
            i++
            index++;
            list['index'] = index;
            if(i == 1){
              this.tableData.push(theme);
              
            }
            this.tableData.push(list);

        } else {
          
          indicatorsdata.forEach(element => {
            let list = {};
            list['par'] = element['par'];
            list['statename'] = this.getstatename(element,"par");
            if(this.districtflag){
              list['distname'] = this.getdistname(element,"par")
            }
            list['value'] = frommodified ? element['updatedVal'] : element['val'];
            list['status'] = element['status'] ? element['status'].toUpperCase() : null;
            list['label'] = element['name'];
            if(element['numdenflag']){
              list['numdenflag'] = true;
              list['numerator_value'] = frommodified ? element['updatedNumerator'] : element['numerator'];
              list['denominator_value'] = frommodified ? element['updatedDenominator'] : element['denominator'];
              list['numerator_label'] = element['numerator_label'];
              list['denominator_label'] = element['denominator_label'];
            }
            list['sno']= element['sno'];
            list['ip'] = element['ip'];
            list['entityUUID'] = element['id'];
            i++
            index++;
            list['index'] = index;
            if(i == 1){
              this.tableData.push(theme);

            }
            this.tableData.push(list);

          });
        }
      }
    });
  });
    
  }
  preparedataforApproval(data){
    let index = 0;
    data.forEach(theme => {
      let i = 0;
      theme['childList'].forEach(list => {
        let frommodified = false;
        if(list['year'] == this.dataSubmitFilter['ay']){
          list['ischecked'] = false;
          let stateindicators = {};
          let indicatorsdata = [];
          let childData = []; 
          Object.keys(this.reportsdata).forEach(key=>{
            Object.keys(this.reportsdata[key]).forEach(element=>{
              Object.keys(this.reportsdata[key][element]).forEach(indid => {
                if(element == list['entityUUID']){
                  stateindicators = this.reportsdata[key][element][indid];
                  this.stateindValue = this.reportsdata[key][element][indid];
                  // if (element == "fb4902c3-00d9-4d49-bc2c-4013faa33fa6")
                  // {
                  //   element="757a7328-2ec9-4c58-97b1-3acf6a155774"
                  //   stateindicators=this.reportsdata[key][element][indid];
                  //   this.stateindValue = this.reportsdata[key][element][indid];
                  // }
                  // console.log("stateee",stateindicators);
                  
                  // this.stateindValue = this.reportsdata[key][element][indid];
                  childData = stateindicators['childData'];
                  if(list['childList'] && list['childList'].length > 0){
                    stateindicators['numdenflag'] = true;
                  }
                  if(key == 'modified'){
                    frommodified = true;
                  }
                }
              })
            })
          });
          
          if(Object.keys(stateindicators).length > 0){
            this.subindicators = [];
            this.subindicatorValue = [];
            this.subindicatorUUID = [];
            this.fileid = [];
            list['par'] = stateindicators['par'];
            list['statename'] = this.getstatename(stateindicators,"par");
            if(this.districtflag){
              list['distname'] = this.getdistname(stateindicators,"par")
            }
            list['value'] = frommodified ? stateindicators['updatedVal'] : stateindicators['val'];
            list['updatedvalue'] = stateindicators['updatedVal'];
            list['fileUUID'] = stateindicators['file_uuid']
            list['status'] = stateindicators['status'] ? stateindicators['status'].toUpperCase() : null;
            list['label'] = stateindicators['name'];
            list['stateid'] = this.userdetails['loggedUserData']['userProfile']['locationId'];
            if(list['label'] == "Whether regular cleaning / disposal of solid waste undertaken and monitored in all ULBs within the district" && list['value'] == "yes" && stateindicators['cmt'] != null){
              list['foc'] = stateindicators['cmt']['foc'];
            } else if(list['label'] == "Regular cleaning of Ghats is happening / Frequency" && list['value'] == "yes" && stateindicators['cmt'] != null){
              list['foc'] = stateindicators['cmt']['foc'];
            } else if(list['label'] == "Whether regular meetings are held with industries (If Yes- No of meetings held and name of industries)" && list['value'] == "yes" && stateindicators['cmt'] != null){
              list['nomh'] = stateindicators['cmt']['nomh'];
              list['noi'] = stateindicators['cmt']['noi'];
            }
            if(stateindicators['numdenflag']){
               stateindicators['childData'].forEach(subind => {
                if(subind['label']){
                 this.subindicators.push({label:subind['label'],fileUUID:subind['fileUUID'],value:subind['value']});
                }
                 if(subind['wrg']){
                  this.subindicatorValue.push({wrg:subind['wrg'],value:subind['value'],id:subind['id'],fileUUID:subind['fileUUID']});
                 } else if(subind['nomh']){
                  this.subindicatorValue.push({nomh:subind['nomh'],value:subind['value'],id:subind['id'],fileUUID:subind['fileUUID']});
                 } else {
                   this.subindicatorValue.push({value:subind['value'],id:subind['id'],fileUUID:subind['fileUUID']});
                 }
                 
                 this.subindicatorUUID.push({id:subind['id'],value:subind['value']});
                list['numdenflag'] = true;
                // list['subindData'] = flag ? this.subindicators : subind;
                list['subindData']=this.subindicators;
                list['valueData'] = this.subindicatorValue;
                list['UUIDlist'] = this.subindicatorUUID;
               });
          }
            i++
            index++;
            list['index'] = index;
            if(i == 1){
              this.tableData.push(theme);
            }
            // console.log("listt",list);
            // if(list['sno']==2.1 )
            
            this.tableData.push(list);
            // console.log('tabledata=',this.tableData);
            // this.showIndicators(this.tableData)
        }
        }
      });
      
    });
    // console.log('tableData',this.tableData);
    this.tableData.forEach(list => {
      if(list.label=="Percentage gap between Solid waste generated & solid waste actually treated in the town- across all ULBs within the district"){
        // console.log('list.sno updated');
        list.sno='2.10';
        list.iNo=2.10;
      }
    })
    // let pushIndicator=false;
    let themeBindicators=[];
    let sno;
    this.tableData.forEach(list => {
      // if(list.sno=="2.1"){
      //   pushIndicator=true;
      // }
      // else if(list.sno=="C")
      // {
      //   pushIndicator=false;
      // }
      sno=list.iNo;
      if (sno>2 && sno<3)
      {
        themeBindicators.push(list);
      }
    })
    this.sortedTableData=this.sortingdata(themeBindicators);
    let ind=0;
    for (let i=0;i<this.tableData.length;i++){
      sno=this.tableData[i].iNo;
      if (sno >2 && sno <3){
        this.tableData[i]=themeBindicators[ind];
        ind++;
      }
      

    }
  }
  sortingdata(data){
      if (data && data.length > 0) {
        data.sort((a, b) => {
          let sno1 = parseInt(a['sno'].replace('.', ''));
          let sno2 = parseInt(b['sno'].replace('.', ''));
          return sno1 > sno2 ? 1 : -1;
        })
      }
      return data;

  }

  prepareDataforHardcodedTable(data) {
    let index = 0;
    let stpyes=false,stpno=true;
    let stateindicators = {};
    data.forEach(theme => {
      let i = 0;
      theme['childList'].forEach(list => {
        let frommodified = false;
        if (list['year'] == this.dataSubmitFilter['ay']) {
          list['ischecked'] = false;
          stateindicators = {};
          Object.keys(this.reportsdata).forEach(key => {
            Object.keys(this.reportsdata[key]).forEach(element => {
              Object.keys(this.reportsdata[key][element]).forEach(indid => {
                if (element == list['entityUUID']) {
                  stateindicators = this.reportsdata[key][element][indid];
                  // console.log('state0000-',stateindicators);
                  if (element == "fb4902c3-00d9-4d49-bc2c-4013faa33fa6" && this.reportsdata[key][element][indid]['val']=='yes')
                  {
                    this.stpyestabledata=[]
                    element="757a7328-2ec9-4c58-97b1-3acf6a155774"
                    stateindicators=this.reportsdata[key][element][indid];
                    stpyes=true;
                  }
                  else if (element == "fb4902c3-00d9-4d49-bc2c-4013faa33fa6" && this.reportsdata[key][element][indid]['val']=='no'){
                    stpno=true;
                    this.stpnotabledata=[];
                    this.stpnotabledata2=[];
                    console.log('stpno',stpno);
                    element="757a7328-2ec9-4c58-97b1-3acf6a155774";
                    stateindicators=this.reportsdata[key][element][indid];
                    element="1122dd8d-33cd-4c54-af8e-8039dd051089";
                    this.stateindValue = this.reportsdata[key][element][indid];

                  }
                }
              });
            })
          });
          if (Object.keys(stateindicators).length > 0) {
            stateindicators['childData'].forEach(childlist => {
              //  this.dynamicTableData =[];
              //  this.springTableData = [];
              if (childlist['isDynamic'] && stateindicators['name'] == "Number of Nalla's in the district flowing into tributaries or Ganga directly") {
                this.dynamicTableData.push(childlist);
              } else if (childlist['isDynamic'] && stateindicators['name'] == "Spring Rejuvenation") {
                this.springTableData.push(childlist);
              } else if (childlist['isDynamic'] && stateindicators['name'] == "Wetland conservation") {
                this.wetlandTableData.push(childlist);
              } else if (childlist['isDynamic'] && stateindicators['name'] == "Small River rejuvenation") {
                this.rivertabledata.push(childlist);
              } else if (childlist['isDynamic'] && stateindicators['name'] == "List of Gross Polluting Industries (GPI)") {
                this.industrytabledata.push(childlist);
              } else if(childlist['isDynamic'] && stateindicators['name'] == "Action taken against non-compliant Industries"){
                this.noncomplainData.push(childlist)
              } else if(childlist['isDynamic'] && stateindicators['name'] == "Tapping of Nalla's"){
                this.nallatabledata.push(childlist)
              } else if(childlist['isDynamic'] && stateindicators['name'] == "Percentage of work completed for new STPs under construction"){
                this.percentagetabledata.push(childlist)
              } else if(childlist['isDynamic'] && stateindicators['name'] == "Reuse of treated waste water for different purposes mentioned below"){
                this.reusagetabledata.push(childlist);
              } else if(childlist['isDynamic'] && stateindicators['name'] == "Availability of fecal sludge treatment plants"){
                this.availabilityTableData.push(childlist);
              }
              // else if(childlist['isDynamic'] && stateindicators['name'] == "Are all STPs in the district operational"){
              //   this.stpyestabledata.push(childlist);
              // }
              else if(childlist['isDynamic'] && stateindicators['name'] == "Sewerage Treatment Plants (STPs) - Functional" &&  stpyes==true){
                this.stpyestabledata.push(childlist);
              }
              else if((childlist['isDynamic'] && stateindicators['name'] == "Sewerage Treatment Plants (STPs) - Functional") && stpno){
                this.stpnotabledata.push(childlist);
                // this.stpnotabledata=stateindicators['chilData'];
                // this.stateindValue['childlist'].forEach(child=>{
                //   this.stpnotabledata.push(child);
                // })
                this.stpnotabledata2=this.stateindValue['childData'];
                console.log('stpnotable data',this.stpnotabledata,'stpnotabledata2',this.stpnotabledata2);
                stpno=false;
              }
    
            });
          }
        }
      })
    })
  }
  getstatename(data,str){
    
    let name;
    this.stateDropDownList.forEach(element=>{
      if(element['uuid'] == data[str]){
        name = element['name'];
      }
    });
    return name;
  }
  getdistname(data,str){
    
    let name;
    this.DistrictList.forEach(element=>{
      if(element['uuid'] == data[str]){
        name = element['name'];
      }
    });
    return name;
  }
  indicatorvaluechange(table,type){
    if(type == 'boolean'){
      table['valuechanged'] = true;
    }
  }
  indicatordoublechange(table){
      table['valuechanged'] = true;
  }
  public basicValidation():boolean{
    if(this.datasubmit == 'districtwise')
      this.validation[0] = this.utils.checkfield(this.distuuid)
    else 
      this.validation[0] = true;
    return this.validation[0]
  }
  getLocationList(){
      let option = {};
      this.stateDropDownList = [];
      let stateuuidlist = [];
      option['pType'] = this.dist_nodal_officer == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['STATE'] : this.constants.LOCATION_CONSTANT['REGION']
      option['cType'] = this.dist_nodal_officer == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['DISTRICT'] : this.constants.LOCATION_CONSTANT['STATE']
      // option['puuid'] = this.constants['COUNTRYUUID']
      // option['type'] = type;
      option["component"] = "";
      option["src"] = "";
      this.activeSpinner = true;
      this.submitdataservice.getLocationList(option).subscribe(data =>{
        if(data){
          // var data = this.submitdataService.getLocationList();
          Object.keys(data).forEach((key) => {
            data[key].forEach(list => {
              this.stateDropDownList.push(list);
              stateuuidlist.push(list.uuid);
            });
          });
          this.stateDropDownList.sort(this.submitdataservice.sortStates("name"))
        }
        else
         this.stateDropDownList = [];
        this.activeSpinner = false;
        if(stateuuidlist.length > 0)
         this.getWindowStatus(stateuuidlist);
    },function(err){
        this.activeSpinner = false;
        if(err['error']){
          this.toastr.error(err['error']['msg'])
        }
      });
  }
  getLocationForDistrict(){
    this.DistrictList = []
    this.distuuid = "null"
    let option = {
      'pType':this.constants.LOCATION_CONSTANT['STATE'],
      'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': this.urlparams['component'] == 'approvals' ? (this.stateuuid != 'null' ? this.stateuuid : null) : this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    };
    this.activespineer = true;
    this.submitdataservice.getLocationListforUser(option).subscribe(data =>{
      this.activespineer = false;
      if(Array.isArray(data)){
        this.DistrictList = data;
      }
      // else
      //  this.fieldDropDownList['DistrictList'] = [];
     
  },function(err){
      this.activespineer = false;
      if(err['error']){
        this.toastr.error(err['error']['msg'])
      }
    })
  }

  getbasicparams(){
    let postdata = {};
    postdata['ay'] = this.dataSubmitFilter['ay'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata["subTp"]= this.dataSubmitFilter['montharray'];
    postdata['component'] = this.constants.COMPONENT['ACTUAL_DATA'];
    postdata["cType"] = (this.districtflag || this.userlocationtype == 'DISTRICT') ?  this.constants.LOCATION_CONSTANT['DISTRICT'] : this.constants.LOCATION_CONSTANT['STATE']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['userType'] = this.userdetails['roles'][0];
    if(this.urlparams['component'] != 'approvals' && this.userdetails['roles'][0] == 'DISTRICT_GANGA_COMMITTEE' ){
      postdata["lu"] =  this.userdetails['loggedUserData']['userProfile']['locationId'];
    }
   if(this.urlparams['component'] == 'approvals'){
      postdata["lu"] = this.userdetails['loggedUserData']['userProfile']['locationId'];
    }
    //console.log('postdata',postdata);
    return postdata;
  }
  
  getLuUUID(stateuuid, distuuid){
    return (distuuid == "null" ? (stateuuid == "null" ? null : stateuuid) : distuuid)
    }
  checkvalue(val){
    if(!val || val == "null" || val == 'undefined'){
      // this.hideRow = true
      return "-";
    }
    return val;
  }
  CheckValue(value){
    if(!value || value == "null" || value == 'undefined'){
      // this.hideRow = true
      return '';
    }
    return value;
  }
  CheckYesNo(val){
    if(val == 'yes' || val == 'no'){
      return true;
    } else{
      return false;
    }
  }
  checkNumOrAlpha(value){
    if(isNaN(value)){
      // this.hideRow = false
      return true
    } else {
      // this.hideRow = false
      return false
    }
  }
  // approveOrrejectclick(action){
  //   let postdata = {};
  //   postdata = this.getbasicparams();
  //   postdata = this.formatdataforbackend(postdata);
  //   let rejectmsg = action == 'reject' ? null : null;
  //   // if(postdata['count']<=0){
  //   //   return this.toastr.error('Please select atleast one record');
  //   // }
  //   if(Object.keys(postdata['lu']).length > 0){
  //     this.activeSpinner = true;
  //     postdata['action'] = this.constants.ACTION[action];
  //     postdata['ts'] = new Date().getTime();
  //     let actionmsg = this.constants.ACTIONMSG[action];
  //     let erroractionmsg = this.constants.ERRORACTIONMSG[action];
  //     let filetype = postdata['count'] == 1 ? this.constants.FILETYPE['indicator'] : this.constants.FILETYPE['indicators'];
  //       this.submitdataservice.approveorreject(postdata).subscribe(data =>{
  //       // if(this.datasubmit == 'statewise' || this.datasubmit == 'districtwise'){
  //       if(data['status']){
  //         if(action=='approve'){
  //           this.toastr.success(postdata['count'] + ' ' + filetype + ' ' + actionmsg);
  //         }else{
  //           this.toastr.success(rejectmsg ? rejectmsg : postdata['count'] + ' ' + filetype + ' ' + actionmsg);
  //         }
  //         this.getReports();
  //       } else if(data.statuscode == 420){
  //         this.logsrv.logoutuserandsessionclear();
  //       }
  //        else {
  //         this.toastr.error(" Time frame for window has been expired ");
  //       }
  //       this.activeSpinner = false;
  //     // }
  //     });
  //   } else {
  //     this.toastr.error('Please select atleast one record')
  //   }
    
  // }
  approveorRejectData(action){
    let postdata = {};
    this.selectedAction = action;
    postdata = this.getbasicparams();
    postdata = this.formatpostData(postdata);
    let rejectmsg = action == 'reject' ? null : null;
    if(Object.keys(postdata['lu']).length > 0){
      this.activeSpinner = true;
      postdata['action'] = this.constants.ACTION[action];
      postdata['ts'] = new Date().getTime();
      let actionmsg = this.constants.ACTIONMSG[action];
      let erroractionmsg = this.constants.ERRORACTIONMSG[action];
      let filetype = postdata['count'] == 1 ? this.constants.FILETYPE['indicator'] : this.constants.FILETYPE['indicators'];
        this.submitdataservice.approveorreject(postdata).subscribe(data =>{
          
        if(data['status']){
          if(action=='approve'){
            this.toastr.success(postdata['count'] + ' ' + filetype + ' ' + actionmsg);
          }else{
            this.toastr.success(rejectmsg ? rejectmsg : postdata['count'] + ' ' + filetype + ' ' + actionmsg);
          }
          this.getReports();
        } else if(data.statuscode == 420){
          this.logsrv.logoutuserandsessionclear();
        }
         else {
          this.toastr.error(" Time frame for window has been expired ");
        }
        this.activeSpinner = false;
      });
    } else {
      this.toastr.error('Please select atleast one record')
    }
    
  }
  // formatdataforbackend(postdata){
  //   let array = [];
  //   let ludata;
  //   postdata['count'] = 0;
  //   if(postdata['lu']){
  //     ludata = postdata['lu'];
  //     delete postdata['lu'];
  //     postdata['lu'] = {
  //       [ludata] : []
  //     }
  //   this.tableData.forEach(element=>{
  //     if(element['type'] == "INDICATOR" || this.stateuuid || this.distuuid){
  //       if(element.ischecked){
  //         postdata['count'] = postdata['count']+1
  //         postdata['lu'][ludata].push(element['entityUUID']);
  //       }
  //     }
  //   })
  //    } else {
  //     postdata['lu'] = {};
  //     let data = [];
  //     this.tableData.forEach(element=>{
  //       if(!element.childList){
  //         data.push(element);
  //       }
  //     });
      
  //     for(let i=0;i<(data).length;i++){
  //         let locationuuid = data[i]['par'];
  //       if(data[i-1] && locationuuid){

  //         let prvlocationuuid = data[i-1]['par'];
  //         if(data[i]['ischecked']){
  //           postdata['count'] = postdata['count']+1
  //           if(locationuuid == prvlocationuuid){
  //             if(postdata['lu'][prvlocationuuid])
  //               postdata['lu'][prvlocationuuid].push(data[i]['entityUUID']);
  //             else if(Object.keys(postdata['lu']).length == 0){
  //               postdata['lu'] = {
  //                 [prvlocationuuid] : []
  //               }
  //               postdata['lu'][prvlocationuuid].push(data[i]['entityUUID']);
  //             } else {
  //               postdata['lu'][prvlocationuuid] = [];
  //               postdata['lu'][prvlocationuuid].push(data[i]['entityUUID']);
  //             }
  //           } else {
  //             if(postdata['lu'][locationuuid])
  //                postdata['lu'][locationuuid].push(data[i]['entityUUID']);
  //             else if(Object.keys(postdata['lu']).length == 0){
  //               postdata['lu'] = {
  //                 [locationuuid] : []
  //               }
  //               postdata['lu'][locationuuid].push(data[i]['entityUUID']);
  //             } else {
  //               postdata['lu'][locationuuid] = [];
  //               postdata['lu'][locationuuid].push(data[i]['entityUUID']);

  //             }
  //           }
  //         }
          
  //       } 
  //       else {
  //         if(data[i]['ischecked']){
  //           postdata['count'] = postdata['count']+1
  //         postdata['lu'] = {
  //           [locationuuid] : []
  //         }
  //         postdata['lu'][locationuuid].push(data[i]['entityUUID']);
  //       }
          
  //       }
        
  //     }
  //   }
  //   return postdata;
  // }
  formatpostData(postdata){
    let array = [];
    let ludata;
    postdata['count'] = 0;
    if(postdata['lu']){
      ludata = postdata['lu'];
      delete postdata['lu'];
      postdata['lu'] = {
        [ludata] : []
      }
    this.tableData.forEach(element=>{
      if(element['type'] == "INDICATOR" || this.stateuuid || this.distuuid){
        if(element.ischecked){
          postdata['count'] = postdata['count']+1
          postdata['lu'][ludata].push(element['entityUUID']);
        }
      }
    })
     } else {
      postdata['lu'] = {};
      let data = [];
      this.tableData.forEach(element=>{
        if(!element.childList){
          data.push(element);
        }
      });
      
      for(let i=0;i<(data).length;i++){
          let locationuuid = data[i]['par'];
        if(data[i-1] && locationuuid){

          let prvlocationuuid = data[i-1]['par'];
          if(data[i]['ischecked']){
            postdata['count'] = postdata['count']+1
            if(locationuuid == prvlocationuuid){
              if(postdata['lu'][prvlocationuuid]){
                postdata['lu'][prvlocationuuid].push(data[i]['entityUUID']);
              } else if(Object.keys(postdata['lu']).length == 0){
                postdata['lu'] = {
                  [prvlocationuuid] : []
                }
                postdata['lu'][prvlocationuuid].push(data[i]['entityUUID']);
              } else {
                postdata['lu'][prvlocationuuid] = [];
                postdata['lu'][prvlocationuuid].push(data[i]['entityUUID']);
              }
            } else {
              if(postdata['lu'][locationuuid])
                 postdata['lu'][locationuuid].push(data[i]['entityUUID']);
              else if(Object.keys(postdata['lu']).length == 0){
                postdata['lu'] = {
                  [locationuuid] : []
                }
                postdata['lu'][locationuuid].push(data[i]['entityUUID']);
              } else {
                postdata['lu'][locationuuid] = [];
                postdata['lu'][locationuuid].push(data[i]['entityUUID']);

              }
            }
          }
          
        } 
        else {
          if(data[i]['ischecked']){
            postdata['count'] = postdata['count']+1
          postdata['lu'] = {
            [locationuuid] : []
          }
          postdata['lu'][locationuuid].push(data[i]['entityUUID']);
        }
          
        }
        
      }
    }
    return postdata;
  }
  checkwinforreject(data){
    let fallinarray = [];
    let exceededarray = [];
    Object.keys(data).forEach(uuid =>{
      // array.push(uuids);
      // console.log(this.windowdata[this.dataSubmitFilter['ay']],this.windowdata[this.dataSubmitFilter['ay']][uuid])
      this.stateDropDownList.forEach(list =>{
        if(list.uuid == uuid){
          if(this.windowdata[this.dataSubmitFilter['ay']][uuid] && !this.windowdata[this.dataSubmitFilter['ay']][uuid].hasOwnProperty("status")){
            if((this.windowdata[this.dataSubmitFilter['ay']][uuid]['sdate'] <= this.datepipe.transform(new Date(), 'yyyyMMdd') && this.datepipe.transform(new Date(), 'yyyyMMdd') <= this.windowdata[this.dataSubmitFilter['ay']][uuid]['edate'])){
              fallinarray.push(list.name)
            } else {
              exceededarray.push(list.name);
            }
          }
        }
      
    });
    });
    if(exceededarray.length == 0){
      return null;
    } else {
      if(fallinarray.length > 0){
        return "for "+fallinarray.join(",")+" states indicators are rejected but "+exceededarray.join(",")+" states indicators are not being rejected due to Date range window has expired"
      } else {
        return " It cannot be rejected due to Date range window has expired"

      }
    }
  }
  checkallset(checkall){
    this.tableData.forEach(element=>{
      if(!element['childList'] ||  element['childList']){
        element['ischecked'] = checkall ? true : false;
      }
    })
  }
  checkhistorydata(checkdata){
    this.historytableobj.forEach(obj =>{
      if(!obj['childList'] ||  obj['childList']){
        obj['ischecked'] = checkdata ? true : false;
      }
    })
  }
  makevalueeditable(list){
    list['editable'] = true;
    list['prevalue'] = list['value']
  }
  resetvalue(list){
    list['editable'] = false;
    list['prevalue'] = list['value']
  }
 
  submitvalue(list){
    // console.log(list);
    
    this.activeSpinner = true;
    // let value = list['currentvaluechangedon'] == 'numerator' ? list['numerator_value'] : (list['currentvaluechangedon'] == 'denominator' ? list['denominator_value'] : list['value'])
    // if(value){
      let postdata = {};
      postdata = this.getbasicparams();
      postdata['lu'] = list['par'];
      postdata['action'] = this.constants.ACTION['modify'];
      postdata['ts'] = new Date().getTime();
      postdata['data'] = JSON.stringify({[this.dataSubmitFilter['ay']]:[{"id":list['entityUUID'],"value":list['value'],"numerator":list['numerator_value'],"denominator":list['denominator_value']}]});
      this.submitdataservice.modifyData(postdata).subscribe(data =>{
        if(data['status']){
          this.toastr.success('Updated Successfully');
          this.getReports();
        }  else if(data.statuscode == 420){
          this.logsrv.logoutuserandsessionclear();
        } else {
          this.toastr.error("Error while updating value")
        }
        this.activeSpinner = false;
      });
   
  }
  formatpostdata(){
    let optionaldata = {};
    optionaldata['ay'] = this.dataSubmitFilter['ay'];
    optionaldata['view'] = this.constants.VIEWS['admin'];
    optionaldata['subTp'] = this.dataSubmitFilter['montharray'];
    optionaldata['component'] = this.constants.COMPONENT['ACTUAL_DATA'];
    optionaldata["cType"] = this.constants.LOCATION_CONSTANT['DISTRICT']
    optionaldata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    optionaldata['userType'] = this.userdetails['roles'][0];
    optionaldata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'];
    return optionaldata;
  }
  submitmodifyData(list){
    this.activeSpinner = true;
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    optionaldata['data'] = JSON.stringify(this.uploadmodifydata(list));
    this.submitdataservice.modifyData(optionaldata).subscribe(data =>{
      if(data['status']){
        this.toastr.success('Updated Successfully');
        this.getReports();
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("Error while updating value")
      }
      this.activeSpinner = false;
    });
  }
  dynamicvaluechange(data){
    data['isEditable'] = true;
  }
  resetdata(data){
    data['isEditable'] = false;
  }
  historyparams(){
    let historydata = {};
    historydata['lu'] =  null;
    historydata['cType'] = this.constants.LOCATION_CONSTANT['DISTRICT']
    historydata['pu'] = this.userdetails['loggedUserData']['userProfile']['locationId'];
    historydata['ay'] = this.dataSubmitFilter['ay'];
    historydata['component'] = this.constants.COMPONENT['ACTUAL_DATA']
    historydata['userId'] =this.userdetails['loggedUserData']['userProfile']['userId'];
    historydata['target'] = this.constants.HISTORY_DATA_OBJ['TARGET'];
    historydata['subTp'] = this.dataSubmitFilter['montharray'];
    historydata['userType'] = this.userdetails['roles'][0];
    return historydata;
  }
  submitdynamicdata(data){
    this.activeSpinner = true;
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    // if(this.stateindValue['name'] == "Number of Nalla's in the district flowing into tributaries or Ganga directly"){
    optionaldata['data'] = JSON.stringify(this.submitnalladata(data));
    // } else if(this.stateindValue['name'] == "Spring Rejuvenation"){
      // optionaldata['data'] == JSON.stringify(this.submitspringdata())
    this.submitdataservice.modifyData(optionaldata).subscribe(data =>{
      if(data['status']){
        this.toastr.success('Updated Successfully');
        this.getReports();
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("Error while updating value")
      }
      this.activeSpinner = false;
    });
  }
  Submitspringdata(data){
    this.activeSpinner = true;
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    optionaldata['data'] = JSON.stringify(this.submitspringdata(data));
    this.submitdataservice.modifyData(optionaldata).subscribe(data =>{
      if(data['status']){
        this.toastr.success('Updated Successfully');
        this.getReports();
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("Error while updating value")
      }
      this.activeSpinner = false;
    });
  }
  uploadmodifydata(list){
    let obj = {
      [this.dataSubmitFilter['ay']] : [],
    }
    this.childList = [];
   list['valueData'].forEach(val => {
    //  if(idval['valuechanged']){
     this.childList.push({"id":val['id'],"value":val['value']});
   });
  obj[this.dataSubmitFilter['ay']].push({"id":list['entityUUID'],"value":list['value'],"cd":this.childList});
  return obj
  }
  wetlanddynamicdata(data){
    this.activeSpinner = true;
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    optionaldata['data'] = JSON.stringify(this.modifydataforwetland(data));
    this.submitdataservice.modifyData(optionaldata).subscribe(data =>{
      if(data['status']){
        this.toastr.success('Updated Successfully');
        this.getReports();
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("Error while updating value")
      }
      this.activeSpinner = false;
    });
  }
  submitriverdata(data){
    this.activeSpinner = true;
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    optionaldata['data'] = JSON.stringify(this.modifydataforriver(data));
    this.submitdataservice.modifyData(optionaldata).subscribe(data =>{
      if(data['status']){
        this.toastr.success('Updated Successfully');
        this.getReports();
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("Error while updating value")
      }
      this.activeSpinner = false;
    });
  }
  submitindustrydata(data){
    this.activeSpinner = true;
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    optionaldata['data'] = JSON.stringify(this.modifydataforindustry(data));
    this.submitdataservice.modifyData(optionaldata).subscribe(data =>{
      if(data['status']){
        this.toastr.success('Updated Successfully');
        this.getReports();
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("Error while updating value")
      }
      this.activeSpinner = false;
    });
  }
  submitclosuredata(data){
    this.activeSpinner = true;
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    optionaldata['data'] = JSON.stringify(this.modifydataforclosure(data));
    this.submitdataservice.modifyData(optionaldata).subscribe(data =>{
      if(data['status']){
        this.toastr.success('Updated Successfully');
        this.getReports();
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("Error while updating value")
      }
      this.activeSpinner = false;
    });
  }
  submitnallamodifydata(data){
    this.activeSpinner = true;
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    optionaldata['data'] = JSON.stringify(this.modifydatafornallatable(data));
    this.submitdataservice.modifyData(optionaldata).subscribe(data =>{
      if(data['status']){
        this.toastr.success('Updated Successfully');
        this.getReports();
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("Error while updating value")
      }
      this.activeSpinner = false;
    });
  }
  submitpercentagedata(data){
    this.activeSpinner = true;
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    optionaldata['data'] = JSON.stringify(this.modifydatafordatatable(data));
    this.submitdataservice.modifyData(optionaldata).subscribe(data =>{
      if(data['status']){
        this.toastr.success('Updated Successfully');
        this.getReports();
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("Error while updating value")
      }
      this.activeSpinner = false;
    });
  }
  submitreusagedata(data){
    this.activeSpinner = true;
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    optionaldata['data'] = JSON.stringify(this.modifydatafordatausage(data));
    this.submitdataservice.modifyData(optionaldata).subscribe(data =>{
      if(data['status']){
        this.toastr.success('Updated Successfully');
        this.getReports();
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("Error while updating value")
      }
      this.activeSpinner = false;
    });
  }
  downloadfilesfordata(subuuid){
    let optionaldata = {};
    optionaldata = this.formatpostdata();
    this.submitdataservice.getValidateReports(optionaldata).subscribe(data =>{
      Object.keys(data).forEach(key =>{
        Object.keys(data[key]).forEach(ind =>{
          Object.keys(data[key][ind]).forEach(childdata =>{
            let statehierachydata = {};
            statehierachydata = data[key][ind][childdata];
            if(Object.keys(statehierachydata).length > 0){
              statehierachydata['childData'].forEach(list => {
                if(subuuid == list['id']){
                  let dowloadingdata = {
                    "fileUUID":list['fileUUID'],
                    "id" :subuuid
                  }
                  this.activeSpinner =true;
                  this.submitdataservice.downloadExcel(dowloadingdata).subscribe(result =>{
                    this.activeSpinner =false;
                   if(!Array.isArray(result)){
                     let fname='report'
                     if(result.type != "application/json"){

                     switch(result.type){
                       case 'image/png':{
                         fname+='.png'
                         break;
                       }
                       case 'application/excel':{
                         fname+='.xlsx'
                         break;
                       }
                       case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':{
                         fname+='.xls'
                         break;
                       }
                       case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':{
                        fname+='.docx'
                        break;
                      }
                      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
                        fname+='.pptx'
                        break
                      }
                      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":{
                        fname+='.ppt'
                        break
                      }  
                       case 'image/jpeg':{
                         fname+='.jpeg'
                         break;
                       }
                       case 'text/plain':{
                         fname+='.txt'
                         break;
                       }
                       case 'application/pdf':{
                         fname+='.pdf'
                         break;
                       }
                       case 'image/jpg':{
                         fname+='.jpg'
                         break;
                       }
                       default:{
                         break;
                       }
                     }
                 
                     this.utils.downloadFile(result,fname);

                    } else {
                      this.toastr.error("some exception occured")
                    }
                   }
                  })
                }
              });
            }
          })
        })
      })
    })

 }
  modifydatafordatausage(data){
    let modifyobj = {
      [this.dataSubmitFilter['ay']] : []
    }
      modifyobj[this.dataSubmitFilter['ay']].push({"id":this.stateindValue['id'],"value":this.stateindValue['val'],"cd":this.reusagetabledata});
    return modifyobj;
  }
  modifydataforavailabletable(data){
    let modifyobj = {
      [this.dataSubmitFilter['ay']] : []
    }
      modifyobj[this.dataSubmitFilter['ay']].push({"id":this.stateindValue['id'],"value":this.stateindValue['val'],"cd":this.availabilityTableData});
    return modifyobj;
  }
  modifydatafordatatable(data){
    let modifyobj = {
      [this.dataSubmitFilter['ay']] : []
    }
      modifyobj[this.dataSubmitFilter['ay']].push({"id":this.stateindValue['id'],"value":this.stateindValue['val'],"cd":this.percentagetabledata});
    return modifyobj;
  }
  modifydataforstpyestable(data){
    let modifyobj = {
      [this.dataSubmitFilter['ay']] : []
    }
      modifyobj[this.dataSubmitFilter['ay']].push({"id":this.stateindValue['id'],"value":this.stateindValue['val'],"cd":this.stpyestabledata});
    return modifyobj;
  }
  modifydatafornallatable(data){
    let modifyobj = {
      [this.dataSubmitFilter['ay']] : []
    }
      modifyobj[this.dataSubmitFilter['ay']].push({"id":this.stateindValue['id'],"value":this.stateindValue['val'],"cd":this.nallatabledata});
    return modifyobj;
  }
  modifydataforclosure(data){
    let modifyobj = {
      [this.dataSubmitFilter['ay']] : []
    }
      modifyobj[this.dataSubmitFilter['ay']].push({"id":this.stateindValue['id'],"value":this.stateindValue['val'],"cd":this.noncomplainData});
    return modifyobj;
  }
  modifydataforindustry(data){
    let finalobj = {
      [this.dataSubmitFilter['ay']] : []
    }
      finalobj[this.dataSubmitFilter['ay']].push({"id":this.stateindValue['id'],"value":this.stateindValue['val'],"cd":this.industrytabledata});
    return finalobj;

  }
  modifydataforwetland(list){
    let obj = {
      [this.dataSubmitFilter['ay']] : []
    }
      obj[this.dataSubmitFilter['ay']].push({"id":this.stateindValue['id'],"value":this.stateindValue['val'],"cd":this.wetlandTableData});
    return obj;

  }
  modifydataforriver(data){
    let finalobj = {
      [this.dataSubmitFilter['ay']] : []
    }
      finalobj[this.dataSubmitFilter['ay']].push({"id":this.stateindValue['id'],"value":this.stateindValue['val'],"cd":this.rivertabledata});
    return finalobj;

  }
  submitnalladata(list){
    let obj = {
      [this.dataSubmitFilter['ay']] : []
    }
      obj[this.dataSubmitFilter['ay']].push({"id":this.stateindValue['id'],"value":this.stateindValue['val'],"cd":this.dynamicTableData});
    return obj;

  }

  submitspringdata(list){
    let obj = {
      [this.dataSubmitFilter['ay']] : []
    }
      obj[this.dataSubmitFilter['ay']].push({"id":this.stateindValue['id'],"value":this.stateindValue['val'],"cd":this.springTableData});
    return obj;
  }
  // openrejectWindow(){
  //   this.modalRef = this.modalService.open(RejectwindowPopupComponent,{ backdrop: 'static',windowClass: 'backgroundTransparent  my-class'});
  //   this.modalRef.componentInstance.indicatorsArray = this.tableData;
  //   this.modalRef.componentInstance.year = this.dataSubmitFilter['ay'];
  //   this.modalRef.componentInstance.action = this.selectedAction;
  //   this.modalRef.componentInstance.month = this.dataSubmitFilter['montharray'];
  //   this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
  // })
  // }
openModal() {
  this.modalReference = this.modalService.open(this.testModal,{windowClass:'submit-modal-centered'});
  this.modalReference.result.then((result) => {
  }, (reason) => {
  });
  this.showIndicators(this.tableData);
}
openDeleteWindow(){
  this.modalReference = this.modalService.open(this.deleteModal);
  this.showIndicators(this.tableData)
}
openpopupModal(){
  this.modalReference = this.modalService.open(this.confirmModal);
  this.modalReference.result.then((result) => {
  }, (reason) => {
  });
  this.getlabelRejectedData();
}
openSubmitWindow(){
  if(this.dateofMeetingPresent){
    this.modalReference = this.modalService.open(this.submitModal,{windowClass:'submit-modal-centered'});
    this.modalReference.result.then((result) => {
    }, (reason) => {
    });
    this.showIndicators(this.tableData);
  }
  else{
    this.modalReference=this.modalService.open(this.alertModal,{windowClass:'submit-modal-centered'});
  }
}
showIndicators(tableData: any[]){
  this.rejectWindowObj = [];
  let rejectObjString: string = '';
  let rejectArray = [];
  tableData.forEach(element => {
    if (element['ischecked']) {
      if (element['sno'] != 'A' && element['sno'] != 'B' && element['sno'] != 'C' && element['sno'] != 'D' && element['sno'] != 'E' && element['sno'] != 'F' && element['sno'] != 'G' && element['sno'] != 'H' && element['sno'] != 'I' && element['sno'] != 'J') {
        if(element['entityUUID'] == "aff6273a-fd36-458a-9b99-5758f5278edd"){
          element['sno'] = '2.10';
        }
        rejectArray.push(element['sno'])       
      }
    }
  });
  rejectObjString = rejectArray.join(", ")
  this.rejectWindowObj.push({ "serialno": rejectObjString });

}
getlabelRejectedData(){
  this.themearrayObject = [];
 this.tableData.forEach(element =>{
   if(element['ischecked']){
     if(element['sno']!='A'){
      this.themearrayObject.push({"label":element['label'],"sno":element['sno'],"entityUUID":element['entityUUID']});
      // console.log(this.themearrayObject)
     }
   }
 })
}
CloseWindowModal(){
  this.modalReference.dismiss();
}
submitPopupModal(){
  let postdata = {};
  let ludata;
  postdata = this.getbasicparams();
  postdata['count'] = 0;
    ludata = postdata['lu'];
    delete postdata['lu'];
    postdata['lu'] = {
      [this.userdetails['loggedUserData']['userProfile']['locationId']] : []
    }
  this.tableData.forEach(element=>{
    if(element['type'] == "INDICATOR"){
      if(element['ischecked']){
        postdata['count'] = postdata['count']+1
        postdata['lu'][this.userdetails['loggedUserData']['userProfile']['locationId']].push(element['entityUUID']);
    }
  }
  });
  let rejectmsg = this.selectedAction == 'reject' ? null : null;
    this.activeSpinner = true;
    postdata['action'] = "APPROVE";
    postdata['ts'] = new Date().getTime();
    let actionmsg = "Approved successfully";
    let erroractionmsg = "rejecting";
    let filetype = postdata['count'] == 1 ? this.constants.FILETYPE['indicator'] : this.constants.FILETYPE['indicators'];
    if(postdata['count'] != 0){

      this.submitdataservice.approveorreject(postdata).subscribe(data =>{
      if(data['status']){
        if(this.selectedAction=='approve'){
          this.toastr.success(postdata['count'] + ' ' + filetype + ' ' + actionmsg);
        }else{
          this.toastr.success(rejectmsg ? rejectmsg : postdata['count'] + ' ' + filetype + ' ' + actionmsg);
        }
        this.modalReference.dismiss();
        this.getReports();
      } else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error(" Time frame for window has been expired ");
      }
      this.activeSpinner = false;
    });
    } else{
      this.toastr.error("Please upload atleast one indicator data");
      this.modalReference.dismiss();
      this.getReports();
      this.activeSpinner = false;
    }
}

deletePopupModal(){
  let postdata;
  postdata = this.getbasicparams();
  postdata['count'] = 0;
  postdata['lu'] = {
    [this.userdetails['loggedUserData']['userProfile']['locationId']] : []
  }
  this.tableData.forEach(element=>{
    if(element['type'] == "INDICATOR"){
      if(element['ischecked']){
        postdata['count'] = postdata['count']+1
        postdata['lu'][this.userdetails['loggedUserData']['userProfile']['locationId']].push(element['entityUUID']);
    }
  }
  });
  postdata['locUUID'] = this.userdetails['loggedUserData']['userProfile']['locationId'];
  postdata['action'] = "REJECT";
  this.activeSpinner = true;
  postdata['ts'] = new Date().getTime();
  let filetype = postdata['count'] == 1 ? this.constants.FILETYPE['indicator'] : this.constants.FILETYPE['indicators'];
  
  console.log("postdata",postdata);
  if(postdata['count'] != 0){
    this.submitdataservice.deleteIndicatorData(postdata).subscribe(data =>{
      if(data['status']){
        this.toastr.success(postdata['count'] + ' ' + filetype + ' ' + 'deleted successfully');
        this.modalReference.dismiss();
      } else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("some exception occured");
        this.modalReference.dismiss();
      }
      this.getReports();
      this.activeSpinner = false;
    });
  } else {
    this.toastr.error("Please select atleast one indicator data");
    this.activeSpinner = false;
    this.modalReference.dismiss();
  }
  

}
submitrejectedRecords(){
  let postdata = {};
  let ludata;
  postdata = this.getbasicparams();
  postdata['count'] = 0;
    ludata = postdata['lu'];
    delete postdata['lu'];
    postdata['lu'] = {
      [this.userdetails['loggedUserData']['userProfile']['locationId']] : []
    }
  this.tableData.forEach(element=>{
    if(element['type'] == "INDICATOR"){
      if(element['ischecked']){
        postdata['count'] = postdata['count']+1
        postdata['lu'][this.userdetails['loggedUserData']['userProfile']['locationId']].push(element['entityUUID']);
    }
  }
  });
  let rejectmsg = this.selectedAction == 'reject' ? null : null;
    this.activeSpinner = true;
    postdata['action'] = "REJECT";
    postdata['ts'] = new Date().getTime();
    let actionmsg = "rejected records successfully";
    let erroractionmsg = "rejecting";
    let filetype = postdata['count'] == 1 ? this.constants.FILETYPE['indicator'] : this.constants.FILETYPE['indicators'];
      this.submitdataservice.approveorreject(postdata).subscribe(data =>{
      if(data['status']){
        if(this.selectedAction=='approve'){
          this.toastr.success(postdata['count'] + ' ' + filetype + ' ' + actionmsg);
        }else{
          this.toastr.success(rejectmsg ? rejectmsg : postdata['count'] + ' ' + filetype + ' ' + actionmsg);
        }
        this.modalReference.dismiss(this.confirmModal);
        this.modalReference.dismiss(this.testModal);
        this.getReports();
      } else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      }
       else {
        this.toastr.error(" Time frame for window has been expired ");
      }
      this.activeSpinner = false;
    });
}
}
